import React, { Component } from 'react'
import {
	CalendarIcon,
	RefreshIcon,
	TrendingUpIcon,
	TrendingDownIcon } from '@heroicons/react/outline'
import InfoTip from './InfoTip'

function fmt(n)
{
	if (n === null || n === undefined)
		return '0'
	return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
}

class StatsPlanningCard extends Component {
	// "DD/MM/YYYY" → "mardi 25 juin" (+ " 2025" en mode "Tout")
	_formatDay = (str, withYear) => {
		const parts = String(str).split('/')
		if (parts.length !== 3)
			return str
		const day = Number(parts[0])
		const month = Number(parts[1]) - 1
		const year = Number(parts[2])
		const date = new Date(year, month, day)
		if (isNaN(date.getTime()))
			return str
		const options = { weekday: 'long', day: 'numeric', month: 'long' }
		if (withYear === true)
			options.year = 'numeric'
		return date.toLocaleDateString('fr-FR', options)
	}

	render() {
		if (this.props.loading === true)
		{
			return (
				<div className="bg-white border border-slate-200 rounded-2xl shadow-sm p-5 animate-pulse h-full">
					<div className="h-3 bg-slate-200 rounded-full w-1/2 mb-4"></div>
					<div className="h-8 bg-slate-200 rounded-lg w-1/3 mb-4"></div>
					<div className="h-4 bg-slate-100 rounded w-2/3"></div>
				</div>
			)
		}
		if (this.props.error === true || !this.props.planning)
		{
			return (
				<div className="bg-white border border-slate-200 rounded-2xl shadow-sm p-5 h-full">
					<h2 className="text-2xs font-black text-slate-400 uppercase tracking-widest mt-0 mb-2">Ouverture du programme</h2>
					<p className="text-sm font-medium text-slate-500 mt-0 mb-3">Données indisponibles.</p>
					<button
						type="button"
						onClick={this.props.onRetry}
						className="inline-flex items-center gap-1.5 px-4 py-2 text-2xs font-black uppercase tracking-widest rounded-xl text-indigo-700 cursor-pointer transition-all active:scale-95 focus:outline-none focus:ring-2 focus:ring-indigo-500"
						style={{ backgroundImage: 'none', backgroundColor: '#eef2ff' }}
					>
						<RefreshIcon className="w-4 h-4" aria-hidden="true" />
						Réessayer
					</button>
				</div>
			)
		}
		const p = this.props.planning
		const rate = p.rate || 0
		const reached = p.reached || 0
		const engaged = p.engaged || 0
		const topDays = p.topDays || []
		const maxDay = (topDays.length > 0) ? Math.max.apply(null, topDays.map(d => d.visitors).concat([1])) : 1
		const delta = (p.rateDelta === null || p.rateDelta === undefined) ? null : p.rateDelta
		let deltaPill = null
		if (delta !== null)
		{
			const pct = Math.round(delta * 100)
			const up = pct >= 0
			deltaPill = (
				<span className={'inline-flex items-center gap-0.5 text-2xs font-black px-2 py-0.5 rounded-full ' + (up ? 'bg-emerald-100 text-emerald-700' : 'bg-rose-100 text-rose-700')}>
					{up
						? <TrendingUpIcon className="w-3 h-3" aria-hidden="true" />
						: <TrendingDownIcon className="w-3 h-3" aria-hidden="true" />}
					{(up ? '+' : '') + pct}%
				</span>
			)
		}
		return (
			<div className="bg-white border border-slate-200 rounded-2xl shadow-sm p-5 h-full">
				<div className="flex items-center justify-between mb-4">
					<span className="inline-flex items-center gap-1">
						<h2 className="text-2xs font-black text-slate-400 uppercase tracking-widest my-0">Ouverture du programme</h2>
						<InfoTip text="Part des visiteurs actifs (qui consultent au moins 3 rubriques) ayant ouvert le programme d'activités." />
					</span>
					<div className="w-9 h-9 rounded-xl bg-emerald-50 flex items-center justify-center flex-shrink-0">
						<CalendarIcon className="w-5 h-5 text-emerald-600" aria-hidden="true" />
					</div>
				</div>
				{engaged === 0
					? <p className="text-sm font-medium text-slate-500 my-0">Pas encore assez d'activité sur cette période pour mesurer l'engagement.</p>
					: (
						<div>
							<div className="flex items-center gap-2">
								<p className="text-3xl font-black text-slate-900 my-0 leading-none">{rate}%</p>
								{deltaPill}
							</div>
							<p className="text-xs font-medium text-slate-400 my-0 mt-2">des visiteurs engagés ouvrent le programme</p>
							<div className="mt-4 pt-4 border-t border-slate-100">
								<p className="text-sm font-semibold text-slate-600 my-0"><span className="font-black text-slate-900">{fmt(reached)}</span> sur {fmt(engaged)} visiteurs engagés</p>
								<p className="text-2xs font-medium text-slate-400 my-0 mt-1">Engagé = a consulté au moins 3 rubriques de l'app</p>
							</div>
							{topDays.length > 0 &&
								<div className="mt-4 pt-4 border-t border-slate-100">
									<p className="text-2xs font-black text-slate-400 uppercase tracking-widest my-0 mb-3">Journées les plus consultées</p>
									<div className="space-y-2.5">
										{topDays.map((d, i) => (
											<div key={i}>
												<div className="flex items-baseline justify-between gap-2">
													<span className="text-sm font-bold text-slate-700 truncate">{this._formatDay(d.date, this.props.days === 0)}</span>
													<span className="text-sm font-black text-slate-600 flex-shrink-0">{fmt(d.visitors)}</span>
												</div>
												<div className="mt-1 h-1.5 bg-slate-100 rounded-full overflow-hidden">
													<div className="h-full bg-emerald-400 rounded-full" style={{ width: Math.round((d.visitors / maxDay) * 100) + '%' }}></div>
												</div>
											</div>
										))}
									</div>
								</div>
							}
						</div>
					)
				}
			</div>
		)
	}
}

export default StatsPlanningCard
